import {NgModule} from '@angular/core'
import {BrowserModule} from '@angular/platform-browser'
import {HTTP_INTERCEPTORS} from '@angular/common/http'

import {initAppModuleImportsBrowser} from '@chatize-ui/utils/init-app-module-imports.browser'
import {initAppProvidersBrowser} from '@chatize-ui/utils/init-app-providers.browser'

import {appEnv} from '@products-ui/env'
import {RequestInterceptor} from '@products-ui/core/interceptors/request.interceptor'

import {AppRoutingModule} from './app-routing.module'
import {AppComponent} from './app.component'

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ...initAppModuleImportsBrowser(),
  ],
  providers: [
    ...initAppProvidersBrowser(appEnv),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
